import {
  forwardRef,
  memo,
  useImperativeHandle,
  useLayoutEffect,
  useRef,
} from 'react';
import { useControl } from '../use-control';
import { CheckboxProps } from '../controls.types';
import { SVG } from 'components/svg';
import { HiddenInput } from '../controls.styled';
import { StyledCheckbox } from './checkbox.styled';
import { Icons } from 'assets';

export const Checkbox = memo(
  forwardRef<HTMLInputElement, CheckboxProps>((props, ref) => {
    const {
      checked: controlledChecked,
      onChange,
      onCheckedChange,
      disabled,
      size = 'm',
      style,
      ...restProps
    } = props;

    const inputRef = useRef<HTMLInputElement>(null);
    const { checked, handleChange } = useControl(
      controlledChecked,
      onChange,
      onCheckedChange
    );

    const isChecked = checked === true;
    const isIndeterminate = checked === 'indeterminate';

    useLayoutEffect(() => {
      if (inputRef.current) {
        inputRef.current.indeterminate = isIndeterminate;
      }
    }, [isIndeterminate]);

    useImperativeHandle(ref, () => inputRef.current!);

    return (
      <StyledCheckbox $size={size} style={style}>
        <HiddenInput
          {...restProps}
          type="checkbox"
          ref={inputRef}
          checked={isChecked}
          onChange={handleChange}
          disabled={disabled}
        />

        {(isChecked || isIndeterminate) && (
          <div className="icon-wrapper">
            <SVG src={isIndeterminate ? Icons.Minus : Icons.Check} />
          </div>
        )}
      </StyledCheckbox>
    );
  })
);

Checkbox.displayName = 'Checkbox';
